<shell-layout *ngIf="config" [error_identity]="true">
  <img src="assets/img/errors/error__timeout.svg" alt="Time Out" class="m-auto" />

  <ui-text color="blue-500" size="h4" weight="semibold" align="center" class="mt-6">
    Ha pasado mucho tiempo
  </ui-text>

  <ui-text color="blue-300" class="mt-3" align="center">
    Por tu seguridad, volveremos al inicio.
  </ui-text>

  <div class="flex justify-center mt-10">
    <ui-button
      (clicked)="closeModal()"
      type="primary"
      label="Reintentar ahora"
    ></ui-button>
  </div>
</shell-layout>
